import { AuthServicesImpl } from 'services/auth/AuthServicesImpl';

export const useLogin = () => {
	const authService = new AuthServicesImpl();

	const login = (success: Function, error: Function) => {
		authService
			.login()
			.then((response) => {
				const { token } = response.data;
				sessionStorage.setItem('session', JSON.stringify({ token: `Bearer ${token}` }));
				success();
			})
			.catch((_) => {
				error();
			});
	};

	return [login] as const;
};
